/**
 * Shared cookie name constants
 * Used by both client and server to ensure consistency
 */

export const COOKIE_NAMES = {
  USER_EMAIL: 'user-email',
  SESSION: '__session',
  LANGUAGE: 'language',
  USER_SETTINGS: 'user_settings',
  FORCED_VARIANTS: 'forced_variants',
  TEMPORARY_FORCED_VARIANTS: 'temporary_forced_variants',
  AMPLITUDE_DEVICE_ID: '__mtaid',
  REFRESHER_KIT_INVITATION: 'refresher_kit_invitation',
} as const
